import { render, staticRenderFns } from "./WsErrorHandler.vue?vue&type=template&id=16cbd841&scoped=true"
import script from "./WsErrorHandler.vue?vue&type=script&lang=js"
export * from "./WsErrorHandler.vue?vue&type=script&lang=js"
import style0 from "./WsErrorHandler.vue?vue&type=style&index=0&id=16cbd841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cbd841",
  null
  
)

export default component.exports